import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './route';
import detectMobile from './DetectecMobile';

// Import Tailwind CSS
import './assets/css/main.css';

Vue.use(VueRouter);

Vue.config.productionTip = false;
Vue.prototype.$mobile = detectMobile;

const app = new Vue({
  el: '#app',
  router: routes,
  render: h => h(App)
});

export default app;
